import { z } from 'zod';
import { uuidSchema } from '../schemas.js';
import { createAutomationSchema } from './definition.js';
export const dryRunRequestSchema = z.object({
    definition: createAutomationSchema,
    /**
     * One session to check instead of the live set; a run's session id, when it had one, and its
     * start when known, which bounds the read.
     */
    sample: z.object({ sessionId: uuidSchema, startedAt: z.coerce.date().optional() }).optional(),
});
//# sourceMappingURL=dryRun.js.map